import { DEFAULT_REGION, parseRegion, type RegionId } from "./regions";

const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/u;

export type ExhibitionSelection =
  | { kind: "menu" }
  | { kind: "exhibition"; slug: string }
  | { kind: "invalid" };

export function readExhibitionSelection(search = window.location.search): ExhibitionSelection {
  const parameters = new URLSearchParams(search);
  const values = parameters.getAll("exhibition");
  if (values.length === 0) return { kind: "menu" };
  const slug = values[0];
  if (values.length !== 1 || slug === undefined || slug.length > 64 || !SLUG.test(slug)) {
    return { kind: "invalid" };
  }
  return { kind: "exhibition", slug };
}

export function selectionUrl(slug: string | null, current = window.location.href): string {
  const url = new URL(current);
  url.searchParams.delete("exhibition");
  if (slug !== null) url.searchParams.set("exhibition", slug);
  url.hash = "";
  return `${url.pathname}${url.search}`;
}

/**
 * Which heritage the index is showing. Anything unrecognised — a region that does not
 * exist, or one that is named on the strip but has no exhibitions behind it yet —
 * falls back to the default rather than rendering an empty museum.
 */
export function readRegion(search = window.location.search): RegionId {
  const values = new URLSearchParams(search).getAll("region");
  if (values.length !== 1) return DEFAULT_REGION;
  return parseRegion(values[0] ?? null) ?? DEFAULT_REGION;
}

/**
 * The default region stays out of the URL. Saudi Arabia is what the site opens on, so
 * every link already in circulation — including the one a client is reading now —
 * keeps meaning exactly what it meant before regions existed.
 */
export function regionUrl(region: RegionId, current = window.location.href): string {
  const url = new URL(current);
  url.searchParams.delete("exhibition");
  if (region === DEFAULT_REGION) url.searchParams.delete("region");
  else url.searchParams.set("region", region);
  url.hash = "";
  return `${url.pathname}${url.search}`;
}
